<template>
<div class="containerWrapper">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <form>
          <vue-form-generator :schema="customerSchema" :model="customerModel" />
        </form>
      </div>
    </div>
  </div>
  <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <Button  label="Spara" class="p-button-success" @click="onSave()" icon="pi pi-check" ></Button>
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import VueFormGenerator from 'vue-form-generator'
import Button from 'primevue/button'
export default {
  name: 'CustomerCreate',
  components: {
    Button,
    'vue-form-generator': VueFormGenerator.component
  },
  data () {
    return {
      customerModel: {},
      customerSchema: {}
    }
  },
  props: {
    schema: {}
  },
  watch: {
    // schema: function (newVal, oldVal) {
    //   this.customerSchema = this.$props.schema
    //   this.customerSchema.fields.push({
    //     type: 'submit',
    //     buttonText: 'Save',
    //     onSubmit: this.onSave
    //   })
    // }
  },
  created () {
    this.customerSchema = this.$route.params.schema
    this.appendtoSchema()
  },
  methods: {
    // appendtoSchema () {
    //   this.customerSchema = this.$route.params.schema
    //   this.customerSchema.groups.push({
    //     legend: '',
    //     fields: [
    //       {
    //         type: 'submit',
    //         buttonText: 'Spara',
    //         onSubmit: this.onSave
    //       },
    //       {
    //         type: 'submit',
    //         buttonText: 'Avbryt',
    //         onSubmit: this.onCancel
    //       }
    //     ]
    //   })
    // },
    onSave () {
      var url = '/api/customers'
      this.$http
        .post(url, {
          customer: {
            type: 'simple',
            ...{
              data: this._.omit(this.customerModel, 'submit')
            }
          }
        })
        .then(response => {
          this.$router.push('/customerList')
        })
        .catch(error => console.log(error))
    },
    onCancel () {
      this.$router.push('/customerList')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Customers/CustomerCreate.vue